import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

// Maps a friendly audience choice to the `editions` array stored on articles/news.
// [] (empty) = shown on every site (default, backward-compatible).
export const audienceToEditions = (a) => (a === "global" ? ["global"] : a === "india" ? ["india"] : []);
export const editionsToAudience = (arr) => {
  if (!arr || arr.length === 0) return "both";
  const s = new Set(arr);
  if (s.has("global") && s.has("india")) return "both";
  if (s.has("india")) return "india";
  if (s.has("global")) return "global";
  return "both";
};

export default function AudienceSelect({ value = [], onChange, testid = "audience", label = "Show on" }) {
  const a = editionsToAudience(value);
  return (
    <div data-testid={testid}>
      {label && <Label>{label}</Label>}
      <Select value={a} onValueChange={(v) => onChange(audienceToEditions(v))}>
        <SelectTrigger className="mt-1" data-testid={`${testid}-trigger`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="both">Both sites (AlumniPulse + IndiaAlumni)</SelectItem>
          <SelectItem value="global">AlumniPulse.net only</SelectItem>
          <SelectItem value="india">IndiaAlumni.com only</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
